"use client";

import { OPPORTUNITY_VIEW_LOCAL_STORAGE_KEY } from "./constants/common";
import type { OpportunityView } from "./types/common";

export const setLocalStorageOpportunityView = (view: OpportunityView) => {
  if (typeof window !== "undefined") {
    localStorage.setItem(OPPORTUNITY_VIEW_LOCAL_STORAGE_KEY, view);
  }
};

export const getLocalStorageOpportunityView = (): OpportunityView | null => {
  if (typeof window !== "undefined") {
    return localStorage.getItem(
      OPPORTUNITY_VIEW_LOCAL_STORAGE_KEY,
    ) as OpportunityView | null;
  }
  return null;
};
